import formComponent from '@/util/proto/formComponent'
import request from '@/util/request'

const result = [
  {value:1 , label:'通过'},
  {value:2 , label:'拒绝'},
]

export default {
  extends: formComponent ,

  props:{
    data:{
      default(){
        return {}
      }
    },
  },
  data() {
    return {
      loading:false,
      state:{
        state:null,
        reviewDesc:null
      }
    }
  },
  created(){
    
  },
  methods:{
    save(){

      if( !this.state.state ){
        this.$Message.error('请选择审核结果')
        return
      }

      if( this.state.state == 2 && !this.state.reviewDesc ){
        this.$Message.error('请填写拒绝理由')
        return
      }

      this.loading = true
      let params = {
        id:this.data.id,
        state:this.state.state,
        reviewDesc:this.state.reviewDesc,
      }

      request.licenseViolationReview(params).then(resp => {
        this.loading = false
        
        if(resp.code){
          this.$Message.error(resp.msg)
        }else{
          this.$Message.success('审核完成')
          this.$emit('ok')
        }
      })  
    },
  },
  render(){
    const { loading , formData , data} = this
    let state = this.state.state;// ? this.form.getFieldValue('reviewResult') : null
    let extra
    if( state == 2 ){
      extra = [
          <sl-detail-list-item label="拒绝原因">
            <Input type="textarea" placeholder="请描述细节" autosize={{ minRows: 2, maxRows: 6 }} v-model={this.state.reviewDesc} />
          </sl-detail-list-item>
      ]
    }
    return (
      <div>
        <div class="modal-body">
          <sl-detail-list label-width={90} col={1}>
            <sl-detail-list-item label="描述">
              <div>{data.eventDesc}</div>
              <div>
                <sl-carousel images={data.eventImages ? data.eventImages.split(';'): []} /> 
              </div>
            </sl-detail-list-item>
            <sl-detail-list-item label="审核结果">
              <sl-select dict={result} type="radio" v-model={this.state.state} />
            </sl-detail-list-item>
            {extra}
          </sl-detail-list>
        </div>
        <div class="modal-footer">
          <Button loading={loading} on-click={this.save} type="primary">确定</Button>
        </div>
      </div>
    )
    
  }
}